module.exports = __webpack_public_path__ + "img/ico-profile-image.50768546.svg";